import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('pkpRecentAuctionsTable', pkpRecentAuctionsTable);

    /**
     * "Ain't Nobody Got Time for That" - flzemke.btc
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpRecentAuctionsTable(DATES, auctionsOverviewService) {
        return {
            restrict: 'E',
            scope: {
                recentAuctions: '=',
                periodType: '=',
                isLoggedIn: '='
            },
            template:
                require('app/_directives/pkp-recent-auctions-table.directive.html'),
            link: function postLink(scope) {
                var PERIOD_TYPE = auctionsOverviewService.PERIOD_TYPE;
                scope.auctionStartFormat = DATES.DATETIME_DEFAULT;
                scope.runtimeFormat = DATES.DATETIME_DEFAULT;

                scope.$watch('periodType', function (newValue) {
                    switch (newValue) {
                        case PERIOD_TYPE.WITHIN_DAY.VALUE: {
                            scope.runtimeFormat = DATES.DATETIME_DEFAULT;
                            break;
                        }
                        case PERIOD_TYPE.DAILY.VALUE: {
                            scope.runtimeFormat = DATES.DATETIME_DEFAULT;
                            break;
                        }
                        case PERIOD_TYPE.REST_OF_YEAR.VALUE:
                        case PERIOD_TYPE.YEARLY.VALUE:
                        case PERIOD_TYPE.QUARTERLY.VALUE:
                        case PERIOD_TYPE.MONTHLY.VALUE: {
                            scope.runtimeFormat = DATES.DATETIME_DEFAULT;
                            break;
                        }
                    }
                });
            }
        };
    }
})();
